import { TFunction } from 'i18next'
import { z } from 'zod'
import { CHECKOUT_TEMPLATES } from '@/utils/checkoutTemplates'

export function buildCustomizeCheckoutSchema(t: TFunction) {
  return z
    .object({
      banner_mobile_top_image: z
        .instanceof(File)
        .refine(
          (file) => ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type),
          {
            message: t('common:invalid_file_type'),
          },
        ),
      banner_mobile_bottom_image: z
        .instanceof(File)
        .refine(
          (file) => ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type),
          {
            message: t('common:invalid_file_type'),
          },
        )
        .optional(),
      banner_desktop_top_image: z
        .instanceof(File)
        .refine(
          (file) => ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type),
          {
            message: t('common:invalid_file_type'),
          },
        )
        .optional(),
      banner_desktop_bottom_image: z
        .instanceof(File)
        .refine(
          (file) => ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type),
          {
            message: t('common:invalid_file_type'),
          },
        )
        .optional(),
      banner_desktop_side_image: z
        .instanceof(File)
        .refine(
          (file) => ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type),
          {
            message: t('common:invalid_file_type'),
          },
        )
        .optional(),
      timer_in_minutes: z.number().int().nullable().optional(),
      show_notification: z.boolean(),
      show_whatsapp_support: z.boolean(),
      whatsapp_support: z.string().optional().nullable(),
      phone_prefix: z.string().optional().nullable(),
      urgency_description: z.string().optional(),
      urgency_background_color: z
        .string()
        .min(1, t('common:required_field'))
        .default('#a1a1a9'),
      urgency_text_color: z.string().min(1, t('common:required_field')),
      name: z.string().min(1, t('common:required_field')),
      show_urgency: z.boolean(),
      banner_mobile_top_is_visible: z.string(),
      banner_mobile_bottom_is_visible: z.string(),
      banner_desktop_top_is_visible: z.string(),
      banner_desktop_bottom_is_visible: z.string(),
      banner_desktop_side_is_visible: z.string(),
      default_payment_method: z.string().min(1, t('common:required_field')),
      template: z.enum(CHECKOUT_TEMPLATES).optional(),
      product_photo: z.any().optional().nullable(),
      remove_product_photo: z.boolean().optional(),
    })
    .superRefine((data, ctx) => {
      if (
        data.show_urgency &&
        (data.timer_in_minutes == null || data.timer_in_minutes < 1)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['timer_in_minutes'],
          message: t('checkouts:timer_min_one_minute'),
        })
      }
    })
}
